import React, { useEffect, useState } from "react";
import Input from "../components/form/Input";
import Label from "../components/form/Label";
import Button from "../components/form/Button";
import Session from "../utils/sessionStorage";
import Header from "../components/Header";
import checkicon from "../assets/svgs/checkicon.svg";
import ErrorModal from "../components/ErrorModal";

const Topup = () => {

  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState(() => {
    const savedAmount = sessionStorage.getItem("topupAmount");
    return savedAmount ? Number(savedAmount) : "";
  });
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const userSession = Session.get("_user_");
  const userData = userSession ? JSON.parse(userSession) : {};
  const saOrgName = userData?.saOrgName;

  /*const submit = async (e) => {
    e.preventDefault();
    try {
      if (amount === "") {
        toast.error("Please, enter amount", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        return;
      }
      setLoading(true);
      const amountVal = amount * 100;
      const response = await axiosInstance.post(
        "api/v1/request-transaction",
        {
          walletUserSessToken: walletUserSess,
          amount: `${amountVal}`,
          consentToken: consentTkn,
          msisdn: userData?.mobileNo,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setLoading(false);
      if (response.status === 200) {
        const { requestTransaction } = response?.data;
        if (requestTransaction) {
          window.location.href = requestTransaction?.redirectUrl;
        }
      }
    } catch (error) {
      setLoading(false);
      setAmount("");
      toast.error(error?.response?.data?.message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };*/

  useEffect(() => {
    if (amount === "") {
      sessionStorage.removeItem("topupAmount");
    } else {
      sessionStorage.setItem("topupAmount", String(amount));
    }
  }, [amount]);

  const submit = async (e) => {
    e.preventDefault();

    if (amount === "") {
      setErrorMessage("Please, enter amount");
      setShowError(true);
      return;
    }

    setLoading(true);

    const amountVal = amount * 100; // Multiply by 100 to add two zeros on the right
    const sAmt = amountVal; // Amt= (e.g., 5 -> 500, 25 -> 2500)
    const sProdSubCode = String(amountVal).padStart(8, "0");
    const sBeneAcctNo = userData?.mobileNo;


    const url = `https://uat.onepay.com.my/dl/${saOrgName}/?OpName=VAS&ProdCode=098&ProdSubCode=${sProdSubCode}&Amt=${sAmt}&BeneAcctNo=${sBeneAcctNo}`;

    window.location.href = url;
    setLoading(false);
  };

  const handleDenomination = (value) => {
    setAmount(value);
  };

  return (
    <div className="bg-accent-grey-50 h-screen lg:w-[450px] w-full mx-auto">
      {/* <div className="flex items-center h-[56px]   rounded-bl-lg rounded-br-lg bg-black "></div>
      <div className="mx-4 px-4 flex justify-start items-center bg-secondary mt-[-23px] h-[43px] rounded-lg">
        <p className="font-poppins font-normal text-base text-white">TopUp</p>
      </div> */}
      <Header />
      <div className="px-4 ">
        <form className="py-5" onSubmit={submit}>
          <div className="flex flex-col items-center ">
            <div className="space-y-[2px] flex flex-col w-full ">
              <Label classes={"text-[#111111CC] text-[13px] font-medium"} labelFor={"msisdn"} content={"Top-Up amount"} />
              <Input
                type={"text"}
                name={"amount"}
                intent={"tertiary"}
                size={"lg"}
                placeholder={"Please select an option below"}
                roundness={"round-sm"}
                classes={"w-full"}
                value={amount}
                //eventAction={handleAmount}
                selector={"amount"}
                readOnly={true}
              />
            </div>
          </div>

          <div className="mt-4">
            <span className="text-[13px] text-gray">
              The amount will be deducted from your E-Wallet and will be added
              to your Voice credit.
            </span>

            <div className="flex items-center justify-start gap-2 flex-wrap mt-6">
              <button
                type="button"
                onClick={() => handleDenomination(5)}
                className={`border-[1px] px-6 py-[6px] rounded-full text-[13px] cursor-pointer flex items-center gap-1 ${amount === 5 ? 'bg-primary text-white border-primary' : 'border-primary text-primary'
                  }`}
              >
                <span>
                  RM
                </span>
                {" "}
                <span >
                  5
                </span>
                {amount === 5 && (
                  <img src={checkicon} alt="" className="ml-1" />
                )}
              </button>
              <button
                type="button"
                onClick={() => handleDenomination(10)}
                className={`border-[1px] px-6 py-[6px] rounded-full text-[13px] cursor-pointer flex items-center gap-1 ${amount === 10 ? 'bg-primary text-white border-primary' : 'border-primary text-primary'
                  }`}
              >
                <span>
                  RM
                </span>
                {" "}
                <span >
                  10
                </span>
                {amount === 10 && (
                  <img src={checkicon} alt="" className="ml-1" />
                )}
              </button>
              <button
                type="button"
                onClick={() => handleDenomination(18)}
                className={`border-[1px] px-6 py-[6px] rounded-full text-[13px] cursor-pointer flex items-center gap-1 ${amount === 18 ? 'bg-primary text-white border-primary' : 'border-primary text-primary'
                  }`}
              >
                <span>
                  RM
                </span>
                {" "}
                <span >
                  18
                </span>
                {amount === 18 && (
                  <img src={checkicon} alt="" className="ml-1" />
                )}
              </button>
              <button
                type="button"
                onClick={() => handleDenomination(22)}
                className={`border-[1px] px-6 py-[6px] rounded-full text-[13px] cursor-pointer flex items-center gap-1 ${amount === 22 ? 'bg-primary text-white border-primary' : 'border-primary text-primary'
                  }`}
              >
                <span>
                  RM
                </span>
                {" "}
                <span >
                  22
                </span>
                {amount === 22 && (
                  <img src={checkicon} alt="" className="ml-1" />
                )}
              </button>
             
              <button
                type="button"
                onClick={() => handleDenomination(30)}
                className={`border-[1px] px-6 py-[6px] rounded-full text-[13px] cursor-pointer flex items-center gap-1 ${amount === 30 ? 'bg-primary text-white border-primary' : 'border-primary text-primary'
                  }`}
              >
                <span>
                  RM
                </span>
                {" "}
                <span >
                  30
                </span>
                {amount === 30 && (
                  <img src={checkicon} alt="" className="ml-1" />
                )}
              </button>
              <button
                type="button"
                onClick={() => handleDenomination(35)}
                className={`border-[1px] px-6 py-[6px] rounded-full text-[13px] cursor-pointer flex items-center gap-1 ${amount === 35 ? 'bg-primary text-white border-primary' : 'border-primary text-primary'
                  }`}
              >
                <span>
                  RM
                </span>
                {" "}
                <span >
                  35
                </span>
                {amount === 35 && (
                  <img src={checkicon} alt="" className="ml-1" />
                )}
              </button>
               <button
                type="button"
                onClick={() => handleDenomination(48)}
                className={`border-[1px] px-6 py-[6px] rounded-full text-[13px] cursor-pointer flex items-center gap-1 ${amount === 48 ? 'bg-primary text-white border-primary' : 'border-primary text-primary'
                  }`}
              >
                <span>
                  RM
                </span>
                {" "}
                <span >
                  48
                </span>
                {amount === 48 && (
                  <img src={checkicon} alt="" className="ml-1" />
                )}
              </button>
              <button
                type="button"
                onClick={() => handleDenomination(50)}
                className={`border-[1px] px-6 py-[6px] rounded-full text-[13px] cursor-pointer flex items-center gap-1 ${amount === 50 ? 'bg-primary text-white border-primary' : 'border-primary text-primary'
                  }`}
              >
                <span>
                  RM
                </span>
                {" "}
                <span >
                  50
                </span>
                {amount === 50 && (
                  <img src={checkicon} alt="" className="ml-1" />
                )}
              </button>
            </div>
          </div>

          <Button
            type={"submit"}
            children={"Topup"}
            intent={"primary"}
            size={"lg"}
            roundness={"round"}
            classes={"w-full mt-10"}
            loading={loading}
          />
        </form>
      </div>
      {showError && <ErrorModal close={() => setShowError(false)} message={errorMessage} />}
    </div>
  );
};

export default Topup;
